import request from '@/utils/request'
import axios from 'axios'
import { getToken, TokenKey } from '@/utils/auth'
import { message } from 'ant-design-vue'

// 健管常用语 右侧分页列表
export function getPageList(data) {
  return request({
    url: '/health-assistant/phraseClassify/pageList',
    method: 'get',
    params: data
  })
}
//健管常用语 左侧树 及获取分类
export function getLeftTree(data) {
  return request({
    url: '/health-assistant/phraseClassify/leftTree',
    method: 'get',
    params: data
  })
}

//健管 新增 编辑 ，删除 常用语分类
export function addOrUpdate(data) {
  return request({
    url: '/health-assistant/phraseClassify/addOrUpdate',
    method: 'post',
    data
  })
}

//健管 新增常用语
export function addPhraseClassify(data) {
  return request({
    url: '/health-assistant/phraseClassify/phrase/addOrUpdate',
    method: 'post',
    data
  })
}
//健管导入常用语
export function phraseClassifyImport(data) {
  return axios({
    method: 'post',
    headers: {
      [TokenKey]: getToken(),
      'content-type': 'multipart/form-data'
    },
    data,
    url: `${process.env.VUE_APP_BASE_API}/health-assistant/phraseClassify/import`
  })
}
//模版下载
export function downLoadTemplate() {
  const hide = message.loading('模版下载中...', 0)
  return axios({
    url: process.env.VUE_APP_BASE_API + '/health-assistant/phraseClassify/template',
    method: 'get',
    responseType: 'blob',
    headers: {
      [TokenKey]: getToken()
    }
  }).then(res => {
    hide()
    if (res.data.type === 'application/json') {
      message.error('下载失败')
    } else {
      const blob = new Blob([res.data])
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, '话术模版.xlsx')
      } else {
        const link = document.createElement('a')
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(blob)
        link.download = '话术模版.xlsx'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      }
    }
  })
}
